// Environment detection utilities
export const isExtension = () => {
  return (
    typeof globalThis.chrome !== 'undefined' && globalThis.chrome.extension
  );
};

export const isPopup = () => {
  return isExtension() && window.location.pathname.includes('popup.html');
};

export const isContentScript = () => {
  return isExtension() && window.location !== window.parent.location;
};

export const isBackground = () => {
  return (
    isExtension() &&
    typeof chrome.runtime !== 'undefined' &&
    chrome.runtime.getManifest
  );
};

export const isWebApp = () => {
  return !isExtension();
};

export const getEnvironmentContext = () => {
  if (isPopup()) return 'popup';
  if (isContentScript()) return 'content';
  if (isBackground()) return 'background';
  if (isWebApp()) return 'web';
  return 'unknown';
};
